var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V2.4H13.2V0H1.2V2.4H2.4V12L0 14.4V16.8H6.24V24H8.16V16.8H14.4V14.4L12 12ZM3.36 14.4L4.8 12.96V2.4H9.6V12.96L11.04 14.4H3.36Z",
    fill: "#2248B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinTrue);
export default __webpack_public_path__ + "static/media/pinTrue.52734d6ad330bb6b8446061691441e0a.svg";
export { ForwardRef as ReactComponent };